export const checkControlLetter = (digits: string, controlLetter: string): boolean => {
    const controlLettersList = 'TRWAGMYFPDXBNJZSQVHLCKE'.split('');

    return controlLettersList[parseInt(digits) % 23] === controlLetter;
};

export const checkDNI = (DNI: string): boolean => {
    const regExp = /^(\d{1,8})([A-Z])$/;

    const isValid = regExp.test(DNI);
    const match = DNI.match(regExp) || [];

    return isValid && Boolean(match.length) && checkControlLetter(match[1], match[2]);
};

export const checkNIE = (NIE: string): boolean => {
    const prefixList = ['X', 'Y', 'Z'];
    const regExp = /^([XYZ])(\d{7})([A-Z])$/;

    const isValid = regExp.test(NIE);
    const match = NIE.match(regExp) || [];

    return isValid && checkControlLetter(prefixList.indexOf(match[1]).toString() + match[2], match[3]);
};
